import { FC } from 'react';
import {
	DocumentType,
	CalendarResponseDto,
} from '@/features/calendar/types/calendar-dto';
import { addMonths, startOfYear } from 'date-fns';
import { BookingCalendar } from '@/components/ui/bookingCalendar';
import { cn } from '@/lib/utils';

type Props = {
	selectedDate: Date;
	isLoading: boolean;
	minWidth?: string;
	showReservationDetails?: (
		id: string,
		type: DocumentType,
		apartmentId?: string,
		checkInDate?: Date,
		checkOutDate?: Date,
	) => void;
} & CalendarResponseDto;

const CalendarMonthly: FC<Props> = ({
	apartments,
	selectedDate,
	isLoading,
	minWidth = '360px',
	showReservationDetails,
}) => {
	const yearStart = startOfYear(selectedDate);

	return (
		<div
			className={cn(`grid gap-4`)}
			style={{
				gridTemplateColumns: `repeat(auto-fill, minmax(${minWidth}, 1fr))`,
			}}>
			{Array.from({ length: 12 }).map((_, index) => {
				const monthDate = addMonths(yearStart, index);

				return (
					<div
						key={index}
						className='p-4 flex items-center justify-center border border-popover-100 rounded-2.5xl bg-popover-10'>
						<BookingCalendar
							month={monthDate}
							apartments={isLoading ? [] : apartments}
							showReservationDetails={showReservationDetails}
						/>
					</div>
				);
			})}
		</div>
	);
};

export default CalendarMonthly;
